<template>
<section>
  <van-radio-group v-model="checkedOptionId" @change="onChange">
    <van-radio
      v-for="(opt, optIndex) in checkItem.choiceOpts"
      :key="optIndex"
      :name="opt.id"
    >{{opt.optionContent}}</van-radio>
  </van-radio-group>
</section>
</template>

<script>
import BaseTaskResultOptionComponent from '../BaseTaskResultOptionComponent'

export default {
  name: 'TaskResultRadio',
  extends: BaseTaskResultOptionComponent,
  OPTION_TYPE: 1,
  getSelected: checkItem => [checkItem.choiceOpts.find(opt => opt.value === 1).optionContent],
  data () {
    let selectedCheckItemOption = this.checkItem.choiceOpts.find(opt => opt.value === 1)

    return {
      checkedOptionId: selectedCheckItemOption ? selectedCheckItemOption.id : ''
    }
  },
  methods: {
    onChange (checkedOptionId) {
      let checkItem = this.checkItem
      let checkItemOption = null

      checkItem.choiceOpts.forEach(opt => {
        if (opt.id === checkedOptionId) {
          opt.value = 1
          checkItemOption = opt
        } else {
          opt.value = 0
        }
      })

      if (checkItemOption) {
        checkItem.score = checkItemOption.score
        checkItem.isCompleted = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.van-radio {
  /deep/ {
    .van-radio__icon {
      padding-top: 1px;

      .van-icon {
        font-size: .65em;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Data/TaskResult/Radio/index.vue